import { roles } from '@/enums'
import { useCurrentRoleStore } from '~/stores/currentRole'

export default defineNuxtRouteMiddleware(async (_to, _from) => {
  const user = useSupabaseUser()
  if (!user.value) return navigateTo('/login')
  const currentRoleStore = useCurrentRoleStore()
  const schoolId = currentRoleStore.getCurrentRole().schoolId
  const schoolRoles = await useSchoolMemberships().load()
  const isStudent = schoolRoles.find(
    (schoolRole: SchoolRole) =>
      schoolRole.schoolId === schoolId && schoolRole.role === roles.STUDENT,
  )
  if (!isStudent) {
    return navigateTo('/')
  }
})
